var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49902 20.498V12.998",
    stroke: "#EA6457",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13H5.25C6.49264 13 7.5 14.0074 7.5 15.25C7.5 16.4926 6.49264 17.5 5.25 17.5H4.5",
    stroke: "#EA6457",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 20.5C12.1569 20.5 13.5 19.1569 13.5 17.5V16C13.5 14.3431 12.1569 13 10.5 13V20.5Z",
    stroke: "#EA6457",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 20.5V14.5C16.5 13.6716 17.1716 13 18 13H19.5",
    stroke: "#EA6457",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.499 17.498H18.749",
    stroke: "#EA6457",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.809 6.55899C23.0904 6.84002 23.2487 7.2213 23.249 7.61899V22C23.2479 23.2415 22.2415 24.2474 21 24.248H3.00002C1.75777 24.2485 0.750128 23.2422 0.749024 22V3.99999C0.748493 3.40273 0.985449 2.82977 1.40768 2.40735C1.82991 1.98493 2.40277 1.74772 3.00002 1.74799H17.377C17.7749 1.74781 18.1566 1.90572 18.438 2.18699L22.809 6.55899Z",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.249 1.74799V6.24799C17.249 7.07641 17.9206 7.74799 18.749 7.74799H23.249",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPdf);
export default __webpack_public_path__ + "static/media/ic-pdf.fad22eeaacaadb11fd9654c1755ed0a8.svg";
export { ForwardRef as ReactComponent };